import React, { useState } from 'react';
import PropTypes, { oneOf } from 'prop-types';
import { useInView, InView } from 'react-intersection-observer';
import LocationCardsStyles from './LocationCards.styled';
import theme from '../../styles/theme';

const LocationCards = ({
  title = '',
  cardOne = null,
  cardTwo = null,
  cardThree = null,
  cardFour = null,
  background = theme.colors.white,
  children,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });

  return (
    <LocationCardsStyles
      ref={ref}
      className={`block-three-cards ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
      background={background}
    >
      <div className='inner'>
        <header>
          {title && <h2>{title}</h2>}
          <hr className='divider' />
          {children}
        </header>
        <InView triggerOnce={true} threshold={0.25}>
          {({ ref: columnsRef, inView: columnsInView }) => (
            <div
              ref={columnsRef}
              className={`columns ${columnsInView ? 'active' : ''}`}
            >
              <div className='column'>
                <div>{cardOne}</div>
                <div>{cardTwo}</div>
              </div>
              <div className='column'>
                <div>{cardThree}</div>
                <div>{cardFour}</div>
              </div>
            </div>
          )}
        </InView>
      </div>
    </LocationCardsStyles>
  );
};

LocationCards.propTypes = {
  title: PropTypes.string,
  CardOne: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  CardTwo: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  CardThree: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  CardFour: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default LocationCards;
